import { render, staticRenderFns } from "./NormalText.vue?vue&type=template&id=a9bb282c&scoped=true&"
import script from "./NormalText.vue?vue&type=script&lang=js&"
export * from "./NormalText.vue?vue&type=script&lang=js&"
import style0 from "./NormalText.vue?vue&type=style&index=0&id=a9bb282c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb282c",
  null
  
)

export default component.exports